/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { EditArticleResponseJson } from './edit-article-response-json';
import { EditArticleResult } from '../results/edit-article-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ArticleDto } from '../models/article-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class EditArticleResponse extends ResponseWithErrorGeneric<EditArticleResponseJson, EditArticleResult> implements IResponseWithErrorGeneric<EditArticleResult> {
  public article: ArticleDto;

  //<custom-body>
  constructor(response: HttpResponse<EditArticleResponse>) {
      super(response, EditArticleResult.Error);
      if (this.result === EditArticleResult.Success) {
        this.article = new ArticleDto(this.body.article);
      }
    }
  //</custom-body>
}
